import { IndiaManifest } from './IND/india.manifest';
import { JapanManifest } from './JPN/japan.manifest';
import { SingaporeManifest } from './SGP/singapore.manifest';
import { HongkongManifest } from './HKG/hongkong.manifest';
import { AustraliaManifest } from './AUS/australia.manifest';
import { NewZealandManifest } from './NZL/newzealand.manifest';
import { ChinaManifest } from './CHN/china.manifest';
import { KoreaManifest } from './KOR/korea.manifest';
import { TaiwanManifest } from './TWN/taiwan.manifest';
import { ThailandManifest } from './THA/thailand.manifest';
import { PhilippinesManifest } from './PHL/philippines.manifest';
import { VietnamManifest } from './VNM/vietnam.manifest';
import { IndonesiaManifest } from './IDN/indonesia.manifest';

export class APACManifest {
  sgpManifest: SingaporeManifest;
  idnManifest: IndonesiaManifest;
  jpaManifest: JapanManifest;
  hkgManifest: HongkongManifest;
  ausManifest: AustraliaManifest;
  nzManifest: NewZealandManifest;
  indManifest: IndiaManifest;
  chnManifest: ChinaManifest;
  korManifest: KoreaManifest;
  twnManifest: TaiwanManifest;
  thaManifest: ThailandManifest;
  phlManifest: PhilippinesManifest;
  vnmManifest: VietnamManifest;

  constructor() {
    this.sgpManifest = new SingaporeManifest();
    this.idnManifest = new IndonesiaManifest();
    this.jpaManifest = new JapanManifest();
    this.hkgManifest = new HongkongManifest();
    this.nzManifest = new NewZealandManifest();
    this.ausManifest = new AustraliaManifest();
    this.indManifest = new IndiaManifest();
    this.chnManifest = new ChinaManifest();
    this.korManifest = new KoreaManifest();
    this.twnManifest = new TaiwanManifest();
    this.thaManifest = new ThailandManifest();
    this.phlManifest = new PhilippinesManifest();
    this.vnmManifest = new VietnamManifest();
  }

  public getAllCountriesManifest() {
    return [
      ...this.sgpManifest.getSGPManifest(),
      ...this.jpaManifest.getJPNManifest(),
      ...this.hkgManifest.getHKGManifest(),
      ...this.ausManifest.getAUSManifest(),
      ...this.nzManifest.getNZManifest(),
      ...this.indManifest.getINDManifest(),
      ...this.chnManifest.getCHNManifest(),
      ...this.korManifest.getKORManifest(),
      ...this.twnManifest.getTWNManifest(),
      ...this.thaManifest.getTHAManifest(),
      ...this.phlManifest.getPHLManifest(),
      ...this.vnmManifest.getVNMManifest(),
      ...this.idnManifest.getIDNManifest()
    ];
  }
}
